export default __webpack_public_path__ + "static/media/jesus-sunset.13d91faf.gif";